// ─── File: ui/src/services/logInsightsService.js ─────────────────────────────
// Follows the existing axiosInstance + Promise pattern from userServices.js.

import { SYSTEM_ERROR } from "../config/CONSTANTS";
import axiosInstance from "./axiosInstance";
import {
  GET_LOG_INSIGHTS_SUMMARY,
  GET_LOG_INSIGHTS_ERRORS,
  CREATE_JIRA_BUG,
} from "./CONSTANTS";

const BASE_URL = process.env.REACT_APP_BASE_URL_CONFIG;

export const getLogInsightsSummary = (days = 7) => {
  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .get(BASE_URL + GET_LOG_INSIGHTS_SUMMARY(), { params: { days } })
        .then((res) => resolve(res.data))
        .catch((err) => resolve(err));
    } catch {
      reject(SYSTEM_ERROR);
    }
  });
};

export const getLogInsightsErrors = (days = 7, level = null) => {
  return new Promise((resolve, reject) => {
    try {
      const params = { days };
      if (level) params.level = level;
      axiosInstance
        .get(BASE_URL + GET_LOG_INSIGHTS_ERRORS(), { params })
        .then((res) => resolve(res.data))
        .catch((err) => resolve(err));
    } catch {
      reject(SYSTEM_ERROR);
    }
  });
};

export const createJiraBug = (endpoint, errorMessage, stackTrace, loggedOnMailId) => {
  return new Promise((resolve, reject) => {
    try {
      axiosInstance
        .post(BASE_URL + CREATE_JIRA_BUG(), {
          endpoint,
          errorMessage,
          stackTrace,
          loggedOnMailId,
        })
        .then((res) => resolve(res?.data))
        .catch((err) => resolve(err));
    } catch {
      reject(SYSTEM_ERROR);
    }
  });
};
